import React, { Component } from 'react';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Table, Form, FormGroup, Input, Label, Button } from 'reactstrap';
import Switch from 'react-switch';
import { connect } from 'react-redux';

class MergeDepartment extends Component {
    static displayName = MergeDepartment.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            tableType: false,
            orphanTable: [",", "."],
            newTable: [",", "."],
            mergeSuccess: false
        }
        this.testPermission();
        this.toggleSwitch = this.toggleSwitch.bind(this);
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            //returnable: this.props.reduxData.userInfo,
            loading: false,
            //username: this.props.reduxData.userInfo.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        var dept = this.props.reduxData.userInfo.level.pk
        //this.recordComingHere();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1030",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1030"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getOrphanList();
        this.getNewList();
    }

    async getOrphanList() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetOrphans', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            orphanTable: data
        })
    }

    async getNewList() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk 
        }
        const response = await fetch('GetNewMergeDept', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            newTable: data
        })
    }

    componentDidMount() {

    }

    async merge(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            orphanDeptPK: dataInput.get('orphan'),
            newDeptPK: dataInput.get('new')
        }
        //console.log("clicc: " + JSON.stringify(toSend));
        const response = await fetch('MergeDepartment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            mergeSuccess: data
        })
        setTimeout(() => {
            this.setState({
                mergeSuccess: false
            })
        }, 3000)
        this.getOrphanList();
        this.getNewList();
    }

    toggleSwitch() {
        this.setState({
            tableType: !this.state.tableType
        })
    }

    orphanTable() {
        return (<tbody>
            {
                this.state.orphanTable.map(orphan => (
                    <tr>
                        <td>{orphan.pk}</td>
                        <td>{orphan.deptname}</td>
                        <td>{orphan.deptemail}</td>
                        <td>{orphan.acadstf}</td>
                        <td>{orphan.parent}</td>
                        <td>{orphan.supervisorupid }</td>
                    </tr>
                    ))
            }
        </tbody>)
    }

    newDeptTable() {
        return (<tbody>
            {this.state.newTable.map(newdept => (
            <tr>
                <td>{newdept.pk}</td>
                <td>{newdept.deptname}</td>
                <td>{newdept.deptemail}</td>
                <td>{newdept.acadstf}</td>
                <td>{newdept.parent}</td>
                <td>{newdept.supervisorupid}</td>
            </tr>
            ))}
        </tbody>)
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        let displayTable = this.orphanTable();
        if (this.state.tableType == true) { displayTable = this.newDeptTable(); }
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form className="d-flex" onSubmit={this.merge.bind(this)}>
                                <FormGroup>
                                    <Label>Orphaned Department</Label>
                                    <Input type="select" name="orphan" id="orphan" defaultValue="DEFAULT">
                                        <option value="DEFAULT" disabled="true">Select...</option>
                                        {this.state.orphanTable.map(orphanOption => (
                                            <option value={orphanOption.pk}>{orphanOption.deptname}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                <FormGroup>
                                    <Label>New Supervisor</Label>
                                    <Input type="select" name="new" id="new" defaultValue="DEFAULT">
                                        <option value="DEFAULT" disabled="true">Select...</option>
                                        {this.state.newTable.map(newOption => (
                                            <option value={newOption.pk}>{newOption.deptname}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                &emsp;
                                &emsp;
                                &emsp;
                                <Button type="submit" outline color="success">Merge</Button>
                            </Form>
                            <div className="centered">Orphaned Departments &nbsp;<Switch uncheckedIcon={false} checkedIcon={false} onChange={this.toggleSwitch} checked={this.state.tableType} onColor={'#888'} height={25} width={50} /> &nbsp; New Departments</div>
                            <Table bordered hover responsive size="sm">
                                <thead>
                                    <tr>
                                        <th>PK</th>
                                        <th>Department Name</th>
                                        <th>Department Email</th>
                                        <th>Acad/Staff</th>
                                        <th>Parent Department Code</th>
                                        <th>Supervisor UPID</th>
                                    </tr>
                                </thead>
                                    {displayTable}
                            </Table>
                        </div>
                    )}
                </UserContext.Consumer>
            );
        
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(MergeDepartment);